'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "className"];
import { jsx as _jsx } from "react/jsx-runtime";
const SingleColumnLayout = _ref => {
  let {
      children,
      className
    } = _ref,
    otherProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx("div", Object.assign({
    className: `${className} single-column-layout`
  }, otherProps, {
    children: children
  }));
};
export default SingleColumnLayout;